export default {
  path: 'provider',
  component: () => import('@/views/provider/specialist-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/specialist-search',
      name: 'specialistSearch',
      component: () =>
        import('@/views/provider/specialist-management/Main.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers.view.specialists'],
        },
      },
    },
    {
      path:
        '/provider/specialist-management/:companyId/:academicYearId?/:specialistId?',
      name: 'specialistManagement',
      component: () =>
        import(
          '@/views/provider/specialist-management/SpecialistManagement.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.providers.view.specialists'],
        },
      },
    },
  ],
};
